/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
import { Heading, FormControl, FormLabel, Input } from "@chakra-ui/react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import moment from "moment";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { useCallback, useEffect, useState } from "react";
import { dateFormat, dateTimeFormat } from "../../utils/constants";

export function CashCenterDetails({ cashCenter = {} }) {
  return (
    <form>
      <Heading style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}>
        Cash Center Information
      </Heading>
      <FormControl>
        <FormLabel>Name</FormLabel>
        <Input readOnly value={cashCenter.name} />
      </FormControl>
      <FormControl>
        <FormLabel>Type</FormLabel>
        <Input readOnly value={cashCenter.type} />
      </FormControl>
      <FormControl>
        <FormLabel>Primary Currency</FormLabel>
        <Input readOnly value={cashCenter.primaryCurrency} />
      </FormControl>
      <FormControl>
        <FormLabel>Barcode</FormLabel>
        <Input readOnly value={cashCenter.barcode} />
      </FormControl>
      <FormControl>
        <FormLabel>Location Id</FormLabel>
        <Input readOnly value={cashCenter.locationId} />
      </FormControl>
      <FormControl>
        <FormLabel>Status</FormLabel>
        <Input readOnly value={cashCenter.status} />
      </FormControl>
      <FormControl>
        <FormLabel>Longitude</FormLabel>
        <Input readOnly value={cashCenter.longitude} />
      </FormControl>
      <FormControl>
        <FormLabel>Latitude</FormLabel>
        <Input readOnly value={cashCenter.latitude} />
      </FormControl>
      <FormControl>
        <FormLabel>Loading Bay Area</FormLabel>
        <Input readOnly value={cashCenter.loadingBayArea} />
      </FormControl>
      <FormControl>
        <FormLabel>Loading Bay Capacity</FormLabel>
        <Input readOnly value={cashCenter.loadingBayCapacity} />
      </FormControl>
      <FormControl>
        <FormLabel>Country</FormLabel>
        <Input readOnly value={cashCenter.country} />
      </FormControl>
      <FormControl>
        <FormLabel>State</FormLabel>
        <Input readOnly value={cashCenter.state} />
      </FormControl>
      <FormControl>
        <FormLabel>Emirate</FormLabel>
        <Input readOnly value={cashCenter.emirate} />
      </FormControl>
      <FormControl>
        <FormLabel>City</FormLabel>
        <Input readOnly value={cashCenter.city} />
      </FormControl>
      <FormControl>
        <FormLabel>Postal Code</FormLabel>
        <Input readOnly value={cashCenter.postalCode} />
      </FormControl>
      <FormControl>
        <FormLabel>Address</FormLabel>
        <Input readOnly value={cashCenter.address} />
      </FormControl>
      <FormControl>
        <FormLabel>First Service Date</FormLabel>
        <Input
          readOnly
          value={moment(cashCenter.firstServiceDate).format(dateFormat)}
        />
      </FormControl>
      <FormControl>
        <FormLabel>Inactive Date</FormLabel>
        <Input
          readOnly
          value={moment(cashCenter.inactiveDate).format(dateFormat)}
        />
      </FormControl>
      <FormControl style={{ width: "100%" }}>
        <FormLabel>Service Days</FormLabel>
        <MultiSelect disabled value={cashCenter.serviceDays} />
      </FormControl>
      {cashCenter.name ? (
        <>
          <Heading
            style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}
          >
            Offices
          </Heading>
          <Offices officesList={cashCenter.offices} />
          <Heading
            style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}
          >
            Operational Windows
          </Heading>
          <OperationalWindow
            operationalWindows={cashCenter.operationalWindows}
          />
          <Heading
            style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}
          >
            Insurance Limits
          </Heading>
          <InsuranceLimits insuranceLimits={cashCenter.insuranceLimits} />
          <Heading
            style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}
          >
            Contact Persons
          </Heading>
          <ContactPersons contactPersons={cashCenter.contactPersons} />
          <Heading
            style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}
          >
            Escalation Groups
          </Heading>
          <EscalationGroups escalationGroups={cashCenter.escalationGroups} />
          <Heading
            style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}
          >
            Internal SLAs
          </Heading>
          <InternalSLAs internalSLAs={cashCenter.internalSLAs} />
        </>
      ) : null}
    </form>
  );
}

function Offices({ officesList = [] }) {
  const [offices, setOffices] = useState([]);
  useEffect(() => {
    setOffices(officesList.map((elm) => ({ ...elm, expanded: false })));
  }, []);
  const expandChange = ({ dataIndex }) => {
    const _offices = [...offices];
    _offices[dataIndex].expanded = !_offices[dataIndex].expanded;
    setOffices(_offices);
  };
  function DetailComponent({ dataItem = {} }) {
    return (
      <>
        <Heading
          style={{
            width: "100%",
            fontSize: "14px",
            padding: "10px 0px",
            margin: 0,
          }}
        >
          Address Information
        </Heading>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: "16px",
          }}
        >
          <FormControl>
            <FormLabel>Country</FormLabel>
            <Input readOnly value={dataItem.country} />
          </FormControl>
          <FormControl>
            <FormLabel>State</FormLabel>
            <Input readOnly value={dataItem.state} />
          </FormControl>
          <FormControl>
            <FormLabel>Emirate</FormLabel>
            <Input readOnly value={dataItem.emirate} />
          </FormControl>
          <FormControl>
            <FormLabel>City</FormLabel>
            <Input readOnly value={dataItem.city} />
          </FormControl>
          <FormControl>
            <FormLabel>Postal Code</FormLabel>
            <Input readOnly value={dataItem.postalCode} />
          </FormControl>
          <FormControl>
            <FormLabel>Address</FormLabel>
            <Input readOnly value={dataItem.address} />
          </FormControl>
          <FormControl>
            <FormLabel>Longitude</FormLabel>
            <Input readOnly value={dataItem.longitude} />
          </FormControl>
          <FormControl>
            <FormLabel>Latitude</FormLabel>
            <Input readOnly value={dataItem.latitude} />
          </FormControl>
        </div>
        <Heading
          style={{
            width: "100%",
            fontSize: "14px",
            padding: "10px 0px",
            margin: 0,
          }}
        >
          Operational Windows
        </Heading>
        <Grid data={dataItem.operationalWindows}>
          <GridColumn
            title="Start Date Time"
            cell={(payload) => (
              <td>
                {moment(payload.dataItem.startDateTime).format(dateTimeFormat)}
              </td>
            )}
          />
          <GridColumn
            title="End Date Time"
            cell={(payload) => (
              <td>
                {moment(payload.dataItem.endDateTime).format(dateTimeFormat)}
              </td>
            )}
          />
          <GridColumn
            title="Cut Off Time"
            cell={(payload) => (
              <td>
                {moment(payload.dataItem.cutOffTime).format(dateTimeFormat)}
              </td>
            )}
          />
        </Grid>
      </>
    );
  }
  const startDateCol = ({ dataItem }) => {
    return <td>{moment(dataItem.startDate).format(dateFormat)}</td>;
  };
  const inActiveDateCol = ({ dataItem }) => {
    return <td>{moment(dataItem.inactiveDate).format(dateFormat)}</td>;
  };
  return (
    <Grid
      data={offices}
      onExpandChange={expandChange}
      detail={DetailComponent}
      expandField="expanded"
    >
      <GridColumn title="Office Id" field="officeId" />
      <GridColumn title="Office Name" field="officeName" />
      <GridColumn title="Office Type" field="officeType" />

      <GridColumn title="Barcode" field="barcode" />
      <GridColumn title="Status" field="status" />

      <GridColumn title="Start Date" field="startDate" cell={startDateCol} />
      <GridColumn
        title="Inactive Date"
        field="inactiveDate"
        cell={inActiveDateCol}
      />
    </Grid>
  );
}

function OperationalWindow({ operationalWindows = [] }) {
  const startDateTimeCol = ({ dataItem }) => {
    return <td>{moment(dataItem.startDateTime).format(dateTimeFormat)}</td>;
  };
  const endDateTimeCol = ({ dataItem }) => {
    return <td>{moment(dataItem.endDateTime).format(dateTimeFormat)}</td>;
  };
  const cutOffTimeCol = ({ dataItem }) => {
    return <td>{moment(dataItem.cutOffTime).format(dateTimeFormat)}</td>;
  };
  return (
    <Grid data={operationalWindows}>
      <GridColumn title="Start Date Time" cell={startDateTimeCol} />
      <GridColumn title="End Date Time" cell={endDateTimeCol} />
      <GridColumn title="Cut Off Time" cell={cutOffTimeCol} />
    </Grid>
  );
}

function InsuranceLimits({ insuranceLimits = [] }) {
  return (
    <Grid data={insuranceLimits}>
      <GridColumn title="Customer Id" field="customerId" />
      <GridColumn title="Currency" field="currency" />
      <GridColumn title="Area" field="area" />
      <GridColumn title="Limit" field="limit" />
    </Grid>
  );
}
function ContactPersons({ contactPersons = [] }) {
  return (
    <Grid data={contactPersons}>
      <GridColumn title="First Name" field="firstName" />
      <GridColumn title="Last Name" field="lastName" />
      <GridColumn title="Mobile No" field="mobileNo" />
      <GridColumn title="Personal Mobile No" field="personalMobileNo" />
      <GridColumn title="Business Contact No" field="officeNo" />
      <GridColumn title="Email" field="email" />
      <GridColumn title="Designation" field="designation" />
    </Grid>
  );
}

function EscalationGroups({ escalationGroups = [] }) {
  const inAppRecipientCol = ({ dataItem }) => {
    return <td>{dataItem.inAppRecipients.join(",")}</td>;
  };
  const emailRecipientCol = ({ dataItem }) => {
    return <td>{dataItem.emailRecipients.join(",")}</td>;
  };
  const callRecipientCol = ({ dataItem }) => {
    return <td>{dataItem.callRecipients.join(",")}</td>;
  };

  return (
    <Grid data={escalationGroups}>
      <GridColumn title="Region" field="region" />
      <GridColumn title="Route" field="routeNo" />
      <GridColumn title="Escalation Level" field="escalationLevel" />
      <GridColumn title="In App Recipient" cell={inAppRecipientCol} />
      <GridColumn title="Email Recipient" cell={emailRecipientCol} />
      <GridColumn title="Call Recipient" cell={callRecipientCol} />
    </Grid>
  );
}

function InternalSLAs({ internalSLAs = [] }) {
  return (
    <Grid data={internalSLAs}>
      <GridColumn title="Region" field="region" />
      <GridColumn title="Service Type" field="serviceType" />
      <GridColumn title="Activity Type" field="activityType" />
      <GridColumn title="Response Time" field="responseTime" />
      <GridColumn title="Attended Time" field="attendedTime" />
      <GridColumn title="Resolution Time" field="resolutionTime" />
    </Grid>
  );
}
